// Reliable cross-window signal for consent popup outcomes.
//
// A consent popup (M365 / NDR / journal-rule) posts its result to the opener
// over a BroadcastChannel, but that fire-and-forget message can be lost when
// the popup auto-closes right after posting. localStorage is synchronous and
// shared across same-origin windows, so the popup also persists its result
// here and the opener reads it after the popup closes. This is what lets a
// `success=false` outcome surface in the opener even if the broadcast is lost.
export const CONSENT_RESULT_KEY = "pt-consent-result";

export interface ConsentResult {
  success: boolean;
  error?: string;
  errorDescription?: string;
}

export const persistConsentResult = (result: ConsentResult): void => {
  try {
    localStorage.setItem(CONSENT_RESULT_KEY, JSON.stringify(result));
  } catch {
    /* localStorage may be unavailable; the BroadcastChannel path still applies */
  }
};

export const readConsentResult = (): ConsentResult | null => {
  try {
    const raw = localStorage.getItem(CONSENT_RESULT_KEY);
    return raw ? (JSON.parse(raw) as ConsentResult) : null;
  } catch {
    return null;
  }
};

export const clearConsentResult = (): void => {
  try {
    localStorage.removeItem(CONSENT_RESULT_KEY);
  } catch {
    /* ignore */
  }
};
